import createStory from './createStory';

const title = "stories coming soon"
const shortName="pillars"
const preview=""

const element0 = <p className="storyBodyText"> coming soon! </p>

const story = [element0]
const pillars = createStory (shortName, title, preview, story)

export default pillars;